import { AxisRenderer, DateAxis } from '@amcharts/amcharts5/xy';

export const dateAxisDataItem = (axis: DateAxis<AxisRenderer>, startDate: Date, endDate: Date) =>
  axis.makeDataItem({
    value: startDate.getTime(),
    endValue: endDate.getTime(),
  });
